import { baseApi } from '@alltrails/redux-helpers/baseApi';
import type {
  AreaSearchResult,
  FilterSearchResult,
  GuideSearchResult,
  ListSearchResult,
  LocationType,
  NaturalLanguageSearchResult,
  PlaceSearchResult,
  POISearchResult,
  SponsoredListSearchResult,
  TrailSearchResult
} from '@alltrails/types/AlgoliaResults';

/**
 * https://github.com/alltrails/explore-service/blob/alpha/api/paths/suggestions.yaml#L12
 */
export type SuggestionsParams = {
  limit?: number;
  localeUnits?: 'metric' | 'imperial';
  query: string;
  recordTypesToReturn?: (
    | TrailSearchResult['type']
    | Omit<LocationType, 'photospot'>
    | 'filter'
    | 'guide'
    | 'list'
    | 'nls_query'
    | 'sponsored_list'
  )[];
};

export type SuggestionsResponse = {
  searchResults: (
    | AreaSearchResult
    | FilterSearchResult
    | GuideSearchResult
    | ListSearchResult
    | NaturalLanguageSearchResult
    | PlaceSearchResult
    | POISearchResult
    | SponsoredListSearchResult
    | TrailSearchResult
  )[];
  summary: {
    count: number;
  };
};

export const suggestionsApi = baseApi.enhanceEndpoints({ addTagTypes: ['Suggestions'] }).injectEndpoints({
  endpoints: builder => ({
    getSuggestions: builder.query<SuggestionsResponse, SuggestionsParams>({
      query: ({ limit, localeUnits, query, recordTypesToReturn }) => {
        return {
          url: `/api/alltrails/explore/v1/suggestions`,
          data: {
            query,
            limit,
            ...(recordTypesToReturn ? { recordTypesToReturn } : {})
          },
          method: 'post',
          ...(localeUnits && { config: { headers: { 'X-Locale-Units': localeUnits } } })
        };
      }
    })
  })
});

export const { useLazyGetSuggestionsQuery } = suggestionsApi;
